import React, { Component } from 'react';
import { Button, Modal, Form, Spinner, ListGroup, InputGroup } from 'react-bootstrap';
import {adriva_sendChatMsg, adriva_ddm_uploadFiless, adriva_getProcessStatus } from '../API';
import './Assistant.css';
import './ProcessStatus.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faCircle,
  faSpinner,
  faTimesCircle,
  faTriangleExclamation,
  faUserGear,
  faRobot,
  faArrowDown
} from '@fortawesome/free-solid-svg-icons';


import  DataModelTreeNode from '../DataModelTreeNode';
import {convertToRawDm, cleanDm} from '../constants';


type Message = {
  sender: 'user' | 'system';
  text?: string;
  component?: React.ReactNode; 
  timestamp: string;  
};


type AriaAssistantProps = {
  appNm: string;
  tool: string;
  useType?: string;
  useData?: any;
  handleUpdateMDMConfig?: (topTableName: string, config: any, beImported: boolean) => void;
  handleUploadMDMConfig?: (dataStr:string, appNm?:string) => void;
  handleStreamlitSetValue?: (val:string) => void;
  handleUsePostAction?: (data:any) => void;
  toggleChat?: () => void;

};

type AriaAssistantState = {
  processId: string | null;
  processSteps: any[];
  error: string | null;
  currentStep?: string;
  status?: string;
  finalMessage?: string; 
  showProcessModal?: boolean; 
  processCompleted?: boolean;

  input: string;
  messages: Message[];
  loading: boolean;
  selectedFiles?: FileList | null;
  userAction?: string;
  questionIndex: number;
  guidedQuestions: any[];
  collectedAnswers: { [key: string]: string };
  dataModel: any  | null;
};


const DDM_stepList = [
  { step: "DATA_PROFILING", label: "Data Profiling", agent: "Data Profiling Processer" },
  { step: "IDENTIFY_LOOKUP_COLUMN", label: "Lookup Column Detection", agent: "Lookup Column Identifier Agent" },
  { step: "BUILDING_DM", label: "Data Model Generation", agent: "Data Model Builder Agent" },
  { step: "IDENTIFY_MDM_DEDUPLICATION_RULE", label: "Identify De-duplication Rules", agent: "Dedups Rule Identifier Agent" },
  { step: "IDENTIFY_BUSINESS_METADATA", label: "Identify Business Metadata/Glossary", agent: "Business Glossary Identifier Agent" },
  { step: "IDENTIFY_DM_POLICY_MAPPING", label: "Identify Data Quality Policies", agent: "Data Management Policy Identifier Agent" },
  { step: "IDENTIFY_VALIDATION_RULE", label: "Identify Data Validation Rules", agent: "Data Validation Rule Identifier Agent" },
  { step: "IDENTIFY_LOOKUP_VALUE_ANOMALIES", label: "Identify Lookup Value Anomalies", agent: "Lookup Data Anomalies Identifier Agent" },
  { step: "STANDARDIZE_LOOKUP_VALUES", label: "Standardize Lookup Values", agent: "Lookup Data Standardizer Agent" },
  { step: "FINALIZE_DQ_RULES", label: "Fianlize Data Quality Rules", agent: "DQ Rules Finalizer Agent" }
];



const SuggestionButtons = ({ onSelect }: { onSelect: (action: string) => void }) => (
  <div className="suggest-buttons">
    <Button size="sm" onClick={() => onSelect('save')} className="me-2">Save</Button>
    <Button size="sm" onClick={() => onSelect('enhance')} className="me-2">Enhance</Button>
    <Button size="sm" onClick={() => onSelect('discard')}>Discard</Button>
  </div>
);


const guidedQuestions_BUILD_NEW_ENTITY = [
  { key: "businessContext", question: "Please describe the client’s business context and industry." },
  { key: "dataDomains", question: "Please enter the entity (Customer, Product, Location, etc.) will be in MDM scope?" },
  /*{ key: "dataSources", question: "What are the primary systems or sources of master data?" },
  { key: "priorityGoals", question: "What are the key goals of building this MDM (e.g., data quality, golden record, compliance)?" }
   */
];

const guidedQuestions_ADD_NEW_ENTITY = [
  { key: "newEntity", question: "Please enter the new entity (Customer, Product, Location, etc.) will be in MDM scope?" },  
];

const guidedQuestions_DDM_BUILD_NEW_ENTITY = [
  { key: "businessContext", question: "Please describe the client’s business context and industry." },
  { key: "dataDomains", question: "Please enter the data doamin (Customer, Product, Location, etc.) will be in MDM scope?" },
  { key: "dataEntity", question: "Please enter the entity (B2B, B2C, HCP, HCO, Material etc.) " },
  { key: "appNm", question: "Please describe the Project Name." },
];

let guidedQuestions_DDM_LKP_VAL_STANDARDIZATION = [
  { key: "lkpType", question: "Please describe the Project Name." },
];

export default class AriaAssistant extends Component<AriaAssistantProps, AriaAssistantState> {
  private chatEndRef: React.RefObject<HTMLDivElement>;
  pollingInterval: NodeJS.Timeout | null = null;

  constructor(props: AriaAssistantProps) {
    super(props);
    this.chatEndRef = React.createRef(); 
    this.state = {
        processId: null,
        processSteps: [],
        error: null,
        input: '',
        messages: [],
        loading: false,
        userAction: 'init_build',
        guidedQuestions: [],
        questionIndex: 0,
        collectedAnswers: {},
        dataModel: null,
    };
  }

  componentDidMount() {
    this.setupGuideQuestions(this.props.useType);
  }

  componentDidUpdate(prevProps: AriaAssistantProps) {
    if (prevProps.useType !== this.props.useType || (this.props.useData && this.props.useData != prevProps.useData)) {
      this.setupGuideQuestions(this.props.useType);
    }
  }

  componentWillUnmount() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  }

  setupGuideQuestions = (useType?: string) =>{
    let guidedQuestions: any[] = [];
    
    if (useType === 'LKP_VAL_STANDARDIZATION' && this.props.useData){
      const lkpFld = this.props.useData['field_name'];
      const lkpFldDesc = this.props.useData['field_description'];
      const lkpVals = this.props.useData['lookup_value'];

      guidedQuestions_DDM_LKP_VAL_STANDARDIZATION = [
        { key: "clientInstructions", question: "Please provide any special instruction for standardizing - " + lkpFldDesc },
      ];
      guidedQuestions = guidedQuestions_DDM_LKP_VAL_STANDARDIZATION;

    }else if (useType === 'BUILD_NEW_ENTITY'){
      guidedQuestions =  guidedQuestions_BUILD_NEW_ENTITY;
    }else if (useType === 'ADD_NEW_ENTITY'){
      guidedQuestions =  guidedQuestions_ADD_NEW_ENTITY;
    }else if (useType === 'DDM_BUILD_NEW_ENTITY'){
      guidedQuestions =  guidedQuestions_DDM_BUILD_NEW_ENTITY;
    }
    this.setState({ guidedQuestions}, this.askNextQuestion);
  }

  askNextQuestion = () => {
    const { questionIndex } = this.state;
    if (questionIndex < this.state.guidedQuestions.length) {
      const nextQ = this.state.guidedQuestions[questionIndex].question;
      const now = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      this.setState(prev => ({
        messages: [...prev.messages, { sender: 'system', text: nextQ, timestamp: now }]
      }), this.scrollToBottom);
    }
  };


  handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ input: e.target.value });
  };

  scrollToBottom = () => {
    if (this.chatEndRef.current) {
      this.chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };


  handleSend = async () => {
    const { input, messages, questionIndex, collectedAnswers } = this.state;
    if (!input.trim()) return;

    const now = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const currentKey = this.state.guidedQuestions[questionIndex]?.key;

    this.setState({
      messages: [...messages, { sender: 'user', text: input, timestamp: now }],
      input: ''
    }, () => {
      if (questionIndex < this.state.guidedQuestions.length) {
        this.setState({
          questionIndex: questionIndex + 1,
          collectedAnswers: {
            ...collectedAnswers,
            [currentKey]: input
          }
        }, () => {
          if (this.state.questionIndex < this.state.guidedQuestions.length) {
            this.askNextQuestion();
          } else {
            if (this.props.tool === 'BUILD_MDM_USING_NLP'){
              this.sendToLLMBackend(input);
            }else if (this.props.tool === 'BUILD_MDM_USING_DATA' || this.props.tool === 'BUILD_DQ_USING_DATA'){
              this.handleDDMFileUpload(input);
            }
          }
        });
      }else{
        if (this.props.tool === 'BUILD_MDM_USING_NLP'){
          this.sendToLLMBackend(input);
        }else if (this.props.tool === 'BUILD_MDM_USING_DATA' || this.props.tool === 'BUILD_DQ_USING_DATA'){
          this.handleDDMFileUpload(input);
        }
      }
    });
  };

  handleDDMFileUpload = async(input?:string) =>{
    const { collectedAnswers, messages, userAction } = this.state;
    const now = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    if (this.props.useType === 'LKP_VAL_STANDARDIZATION'){
      this.setState({loading: true});
      const addlInput = this.props.useData; 
      addlInput['agent'] = 'LookupDataStandardizeAssistant'; 
      addlInput['client_notes'] = collectedAnswers['clientInstructions'];
      const response = await adriva_sendChatMsg(this.props.appNm, '','111', JSON.stringify(addlInput));

      console.log(response);
      if (response && response.success && this.props.handleUsePostAction){
        this.setState({
          loading: false,
          messages: [...messages,
            { sender: 'system', text: 'Standardization done sucessfully', timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }
          ]
        }, this.scrollToBottom);
        this.props.handleUsePostAction(response.data);      
        return;

      }else{
        this.setState({
          loading: false,
          messages: [...messages,
            { sender: 'system', text: response.error || response.message, timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }
          ]
        }, this.scrollToBottom);
        return;
      }
      
    }

    const suggestComponent = (
        <div>
          <div className='my-2'>Please provide sample data</div>
          <Form.Group className="mb-1 mt-2">
              <Form.Control type="file" onChange={this.handleFileChange} multiple className='mb-2'/>
              <Button size="sm" onClick={this.handleFileUpload}>Upload</Button>
            </Form.Group>
        </div>
      );

      this.setState({
        loading: false,
        messages: [
          ...messages,
          { sender: 'system', component: suggestComponent, timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }
        ]
      }, this.scrollToBottom);

    
  }

  sendToLLMBackend = async (input?:string) => {
    const { collectedAnswers, messages, userAction } = this.state;
    const now = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

     

    let prompt = '';
    if (userAction === 'init_build'){
      prompt = `Build a data model based on: ${JSON.stringify(collectedAnswers, null, 2)}`;
    }else if (userAction === 'enhance'){
      prompt = `Enhance the attributes of the subentity ${input} based on: ${JSON.stringify(collectedAnswers, null, 2)}`;
    }else if (userAction === 'save'){
       this.handleSaveEntity(input);
    }

    this.setState({loading: true});
    const addlInput = {}; 
    const response = await adriva_sendChatMsg(this.props.appNm, prompt,'111', JSON.stringify(addlInput));

    console.log(response);
    if (response.success && response.message === "Entity model created successfully"){
      const suggestComponent = (
        <>
          ✅ Model created successfully. What would you like to do?
          <SuggestionButtons onSelect={this.handleSuggestChoice} />
        </>
      );

      this.setState({
        dataModel: response.data_json,
        loading: false,
        messages: [
          ...messages,
          { sender: 'system', component: suggestComponent, timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }
        ]
      }, this.scrollToBottom);
      

    }else{
      this.setState({
        loading: false,
        messages: [...messages,
          { sender: 'system', text: response.error || response.message, timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }
        ]
      }, this.scrollToBottom);

    }


  };


  handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ selectedFiles: e.target.files });
  };

  handleFileUpload = async () => {
    const { selectedFiles } = this.state;
    if (!selectedFiles || selectedFiles.length === 0) return;

    this.setState({ loading: true, processSteps: [], error: null, showProcessModal: false, processCompleted:false });

    const { collectedAnswers } = this.state;

    try {
      const response = await adriva_ddm_uploadFiless(
        collectedAnswers['appNm'],
        collectedAnswers['businessContext'],
        collectedAnswers['dataDomains'],
        collectedAnswers['dataEntity'],
        selectedFiles
      );

      if (response && response.success && response.process_id) {
        const processId = response.process_id;

        // Save processId and initiate step polling
        this.setState({ processId, processSteps: [{ step: "Starting", status: "✅" }] });

        this.pollProcessStatus(processId);
      } else {
        this.setState({ loading: false, error: "File upload failed" });
      }
    } catch (err) {
      console.error(err);
      this.setState({ loading: false, error: "An error occurred during upload." });
    }
  };

  /*
  handleFileUpload = async () => {
    if (!this.state.file) return;

    this.setState({ loading: true });
    const { collectedAnswers, messages, userAction } = this.state;
    const response = await adriva_ddm_uploadFiless(collectedAnswers['appNm'],collectedAnswers['businessContext'],
      collectedAnswers['dataDomains'],collectedAnswers['dataEntity'],
      this.state.file
    )

    if (response && response.success){
      let postData ={
          action: "MDM_APP_SELECTED",
          selected_tool: this.props.tool,
          data: {
            nm: collectedAnswers['appNm']
          }
        }
        this.props.handleStreamlitSetValue && this.props.handleStreamlitSetValue(JSON.stringify(postData));
    }

  };*/

  pollProcessStatus = (processId: string) => {
  this.pollingInterval = setInterval(async () => {
    try {
      const status = await adriva_getProcessStatus(processId);
	  
    /*   const stepList = [
        { step: "DATA_PROFILING", label: "Data Profiling", agent: "Data Profiling Processer" },
        { step: "IDENTIFY_LOOKUP_COLUMN", label: "Lookup Column Detection", agent: "Lookup Column Identifier Agent" },
        { step: "BUILDING_DM", label: "Data Model Generation", agent: "Data Model Builder Agent" },

        { step: "IDENTIFY_MDM_DEDUPLICATION_RULE", label: "Indentify De-duplication Rules", agent: "Dedups Rule Identifier Agent" },
        { step: "IDENTIFY_BUSINESS_METADATA", label: "Identify Business Metadata/Glossary", agent: "Business Glossary Identifier Agent" },
        { step: "IDENTIFY_DM_POLICY_MAPPING", label: "Identify Data Management Policies", agent: "Data Management Policy Identifier Agent" },

        { step: "IDENTIFY_VALIDATION_RULE", label: "Indentify Data Validation Rules", agent: "Data Validation Rule Identifier Agent" },
        { step: "IDENTIFY_LOOKUP_VALUE_ANOMALIES", label: "Identify Lookup Value Anomalies", agent: "Lookup Data Anomalies Identifier Agent" },
        { step: "STANDARDIZE_LOOKUP_VALUES", label: "Lookup Data (code-value) Standardizer", agent: "Lookup Data Standardizer Agent" }
      ];
   */

      if (status) {
        const stepsUI = DDM_stepList.map((stepObj) => {
          const idx = DDM_stepList.findIndex(s => s.step === stepObj.step);
          const currentIdx = DDM_stepList.findIndex(s => s.step === status.current_step);
          let state = "yettostart";
          if (idx < currentIdx) state = "completed";
          else if (idx === currentIdx && status.status === 'failed') state = "failed";
          else if (idx === currentIdx) state = "inprogress";

          return { ...stepObj, status: state };
        });

        this.setState({ processSteps: stepsUI, showProcessModal: true });

        if (["completed", "failed"].includes(status.status)) {
          if (this.pollingInterval) {
              clearInterval(this.pollingInterval);
              this.pollingInterval = null;
          }
          this.setState({
            loading: false,
            finalMessage: status.message || (status.status === "completed" ? "All steps completed successfully!" : "Process failed."),
            processCompleted: true
          });
          
        }
      }
    } catch (err) {
      console.error("Polling error", err);
      if (this.pollingInterval) {
		  clearInterval(this.pollingInterval);
		  this.pollingInterval = null;
	  }
      this.setState({ loading: false, error: "Error polling status." });
    }
  }, 5000);
};



  handleSuggestClick = (question: string) => {
    this.setState({ input: question }, this.handleSend);
  };

  handleDataModelSuggestionAccpted = ()=>{

  }

  
  handleSuggestChoice = (action: string) => {
    const now = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    let msg = "";
    
    switch (action) {
      case 'save':
        console.log("Saving...");
        if(this.props.appNm === 'INITIAL_PAGE'){
          msg = "Provide a client/application name";
        }else{
          this.handleSaveEntity();
          return;
        }
        break;
      case 'view':
        console.log("Showing full model...");
        // Expand view in right panel or trigger detail view
        break;
      case 'enhance':
        console.log("Trigger refinement...");
        msg = "Provide details about which sub-entity you want to add or enhance attributes for?";
        break;
      case 'discard':
        console.log("Model discarded.");
        this.setState({ dataModel: null });
        break;
      default:
        break;
    }


    this.setState(prev => ({
      userAction: action,
      messages: [
        ...prev.messages,
        { sender: 'system', text: msg, timestamp: now }
      ]
    }), this.scrollToBottom);
    
  };

  handleSaveEntity = (appNm?:string)=>{
   
    const dm: { [key: string]: any } = {};
    const refDM: any[] = [];
    const be = this.state.dataModel;
    be['imported'] = true;
    be['buildBy'] = 'ARIA';
    be['entityId'] = be.name;
    be['matchRules'] = [];
    dm[be.name] = be;
    if (this.props.appNm === 'INITIAL_PAGE'){
      const rawDM = convertToRawDm(dm);
      const srcSystems:any[] = [];
      refDM.push(be);
      cleanDm(refDM, srcSystems);
      
      const finalData ={
        "dm": rawDM,
        "refinedDM": refDM,
        "srcSystem": srcSystems,
        "relationships": [],
        "hierarchies": []
      }
      console.log(finalData);
      this.props.handleUploadMDMConfig && this.props.handleUploadMDMConfig(JSON.stringify(finalData), appNm);
    }else{
      this.props.handleUpdateMDMConfig && this.props.handleUpdateMDMConfig('', be, true);
    }
  }

  getStatusIcon = (status: string) => {
    switch (status) {
      case "✅":
        return <FontAwesomeIcon icon={faCheckCircle} className="text-success" />;
      case "⏳":
        return <FontAwesomeIcon icon={faSpinner} spin className="text-info" />;
      case "❌":
        return <FontAwesomeIcon icon={faTimesCircle} className="text-danger" />;
      case "⏺️":
      default:
        return <FontAwesomeIcon icon={faCircle} className="text-muted" />;
    }
  };


  renderProcessModal() {
    const { processSteps, finalMessage, processCompleted } = this.state;

    return (
      <div className="modal d-block" tabIndex={-1} style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Agent Execution Pipeline</h5>
              <button type="button" className="btn-close" onClick={() => this.setState({ showProcessModal: false })}></button>
            </div>
            <div className="modal-body">
              <div className="process-flow-container">
                {processSteps.map((step, index) => {
                  let statusClass = "pending";
                  let icon = <FontAwesomeIcon icon={faCircle} className="text-secondary" />;
                  let statusLabel = "Yet to Start";
                  if (step.status === "completed" || processCompleted) {
                    statusClass = "completed";
                    statusLabel = "Completed";
                    icon = <FontAwesomeIcon icon={faCheckCircle} className="text-success" />;
                  } else if (step.status === "inprogress") {
                    statusClass = "inprogress";
                    statusLabel = "In-progress";
                    icon = <FontAwesomeIcon icon={faSpinner} className="text-warning fa-spin" />;
                  } else if (step.status === "failed") {
                    statusClass = "failed";
                    statusLabel = "Failed";
                    icon = <FontAwesomeIcon icon={faTriangleExclamation} className="text-danger" />;
                  }

                  return (
                    <div key={index}>
                      <div className={`process-step-box ${statusClass}`}>
                        <div className="process-step-title d-flex align-items-center">
                          <span className="me-2">{icon}</span>
                          <span>{step.label}</span>
                        </div>
                        <div className="process-step-status">{statusLabel}</div>
                        <div className="process-step-agent">
                          <FontAwesomeIcon icon={faRobot} className="me-1 text-purple" />
                          Agent: {step.agent}
                        </div>
                      </div>
                      {index !== processSteps.length - 1 && <div className="arrow-down" />}
                      {/*
                      <div className={`process-step-box ${statusClass}`}>
                        <div className="d-flex align-items-center">
                          <div className="process-step-icon">{icon}</div>
                          <div>
                            <div className="process-step-title">{step.step.replace(/_/g, " ")}</div>
                            <div className="process-step-status">{step.status === "⏳" ? "In Progress" : step.status === "✅" ? "Completed" : "Pending"}</div>
                          </div>
                          <div className="process-step-agent">🤖 Agent {step.agent}</div>
                        </div>
                      </div>
                      {index !== processSteps.length - 1 && <div className="arrow-down" />}*/}
                    </div>
                  );
                })}
                {finalMessage && (
                  <div className="alert alert-info mt-3">
                    <strong>Status:</strong> {finalMessage}
                  </div>
                )}
                {processCompleted && (
                  <div className="text-center mt-4">
                    <button
                      className="btn btn-primary"
                      onClick={() => this.handleMoveToApplication()}
                    >
                      🚀 Move to Application
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }


  handleMoveToApplication = () => {
    // You can navigate or trigger an action
    const { collectedAnswers } = this.state;
    const postData = {
      action: "MDM_APP_SELECTED",
      selected_tool: this.props.tool,
      data: {
        nm: collectedAnswers['appNm']
      }
    };

    this.props.handleStreamlitSetValue &&
      this.props.handleStreamlitSetValue(JSON.stringify(postData));

    // Close modal or show success
    this.setState({ showProcessModal: false });
  };



  render() {
    const { messages, input, loading } = this.state;
    const suggestiveQs = ['What is Reltio?', 'Suggest a data model', 'Migrate from Informatica'];

    return (
      <>
       
       
        <div className="d-flex justify-content-between component" style={{ height: '100%', maxHeight: '100vh', overflow: 'hidden' }}>
          {/* LEFT CHAT PANE */}
          <div className="d-flex flex-column" style={{ width: '50%', height: '100%' }}>
            
            {/* CHAT HISTORY */}
            <div className="chat-history flex-grow-1 overflow-auto mb-2">
              {messages.map((msg, idx) => (
                <div key={idx} className={`d-flex mb-2 ${msg.sender === 'user' ? 'justify-content-end' : 'justify-content-start'}`}>
                  <div className={`chat-bubble ${msg.sender}`}>
                    <div className="chat-label">
                      {msg.sender === 'user' ? 'You' : 'Aria'} • {msg.timestamp}
                    </div>
                    <div className="chat-text">{msg.text}</div>
                    {msg.component && msg.component}
                  </div>
                </div>
              ))}
              <div ref={this.chatEndRef}></div>
              {loading && (
                <div className="chat-bubble system">
                  <div className="chat-text"><Spinner animation="border" size="sm" /></div>
                </div>
              )}
              
            </div>

            {/* FILE UPLOAD 
            <Form.Group className="mb-1">
              <Form.Control type="file" onChange={this.handleFileChange} />
              <Button size="sm" onClick={this.handleFileUpload}>Upload</Button>
            </Form.Group>*/}

            {/* INPUT + SEND */}
            <InputGroup>
              <Form.Control
                as="textarea"
                rows={3}
                value={input}
                onChange={this.handleInput}
                onKeyDown={e => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault(); // Prevent newline
                    this.handleSend();  // Trigger send
                  }
                }}
                placeholder="Type your message..."
              />
              <Button onClick={this.handleSend} disabled={loading}>Send</Button>
            </InputGroup>
          </div>

          {/* RIGHT PANE: TREE + ACCEPT */}
          <div style={{ width: '48%', height: '100%', overflowY: 'auto' }}>
            <DataModelTreeNode dataModelData={this.state.dataModel} />
            
          </div>
        </div>

        {this.state.showProcessModal && this.renderProcessModal()} 
          
      </>
    );
  }
}



